import {ChangeDetectorRef, Component, HostBinding, Input, OnInit} from '@angular/core';
import {AdvertisedDeployable, deployableSortingFunction} from "@webmate-web-core/shared/types/devices/device-template";
import {DeviceSlot} from "@webmate-web-core/shared/types/devices/device-slot";
import {map, mergeMap} from "rxjs/operators";
import {DeployableService} from "@webmate-web-core/shared/services/device/deployable.service";
import {LogoResolverService} from "@webmate-web-core/shared/services/logo-resolver.service";

@Component({
  selector: 'wm-slot-icon',
  templateUrl: './slot-icon.component.html',
  styleUrls: ['./slot-icon.component.less']
})
export class SlotIconComponent implements OnInit {

    @Input() slot: DeviceSlot;
    @Input() matchOverview = false;
    @HostBinding('class.match-overview') get usesOverviewDimensions(): boolean {
        return this.matchOverview;
    }

    advertisedDeployables: AdvertisedDeployable[] = undefined;

  constructor(private deployableService: DeployableService, private platformLogoResolver: LogoResolverService, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
      if (!this.slot.isPublicSlot() && !this.slot.isVCloudSlot()) {
          this.deployableService.getDeployablesForSlot$(this.slot.id, true)
              .pipe(
                  map(d => d.sort(deployableSortingFunction)),
                  mergeMap(deployables =>  this.platformLogoResolver.getLogosForDeployables(deployables))
              )
              .subscribe(logos => {this.advertisedDeployables = logos; this.cdRef.markForCheck()});
      } else {
          this.advertisedDeployables = [];
      }
  }

}
